import React from "react"
import type { ContentBlock } from "../../data/types"
import { Markdown } from "./Markdown"

type ContentSectionsProps = {
  sections: ContentBlock[]
}

export const ContentSections = ({ sections }: ContentSectionsProps) => (
  <section className="text-gray-700 body-font">
    <div className="container mx-auto px-5 py-10">
      <div className="max-w-3xl space-y-10">
        {sections.map((section, idx) => (
          <article key={idx}>
            {section.heading ? (
              <h2 className="title-font text-2xl md:text-3xl font-medium text-gray-900 mb-4">
                {section.heading}
              </h2>
            ) : null}
            <div className="text-base md:text-lg leading-relaxed text-gray-700">
              <Markdown source={section.body} />
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
)
